export const dummy=[
    {
        name:"Hoodie",
        price:35,
        image:"https://5.imimg.com/data5/SELLER/Default/2021/2/AT/SP/TE/121749566/pink-men-500x500.png",
        color:"Pink",
        size:"L",
        gender:'M',
        stock:1,
        quantity:10

    },{
        name:"Hoodie",
        price:45,
        image:"https://m.media-amazon.com/images/I/71sDlCSA1rL._UX522_.jpg",
        color:"Red",
        size:"L",
        gender:'F',
        stock:0,
        quantity:0

    },{
        name:"Tshirt",
        price:25,
        image:"https://5.imimg.com/data5/YX/OO/TA/ANDROID-108727015/product-jpeg-500x500.jpg",
        color:"White",
        size:"S",
        gender:'F',
        stock:1,
        quantity:50

    },{
        name:"Goth Jacket",
        price:65,
        image:"https://i.pinimg.com/originals/e5/c7/e5/e5c7e5aed1f84773cf4dd1cd5acc79df.jpg",
        color:"Black",
        size:"XL",
        gender:'F',
        stock:1,
        quantity:100

    },{
        name:"Jacket",
        price:35,
        image:"https://5.imimg.com/data5/YF/IV/MY-41665964/mens-jacket-500x500.jpg",
        color:"Green",
        size:"L",
        gender:'M',
        stock:1,
        quantity:10

    },{
        name:"Sweater",
        price:45,
        image:"https://assets.ajio.com/medias/sys_master/root/20200825/oZ29/5f44094caeb2693e046fc1d1/-473Wx593H-460683064-darkpink-MODEL3.jpg",
        color:"Pink",
        size:"M",
        gender:'F',
        stock:1,
        quantity:80

    },{
        name:"Sweater",
        price:45,
        image:"http://cache.mrporter.com/variants/images/1647597278492489/in/w2000_q60.jpg",
        color:"Blue",
        size:"L",
        gender:'M',
        stock:1,
        quantity:10

    },
]